<template>
  <div class="container">

    <div class="row px-0 mx-1 contenedor">

      <div id="image-card" class="col-md-6">
        <div class="align-items-center">
          <img class="banner-image" :src="'https://mybarber.howertpi.com/assets/' + logo" alt="Logo empresa">
        </div>
      </div>

      <div id="login-card" class="col-md-6">
        <div class="align-items-center">
          <h4>¿EN QUÉ SEDE DESEA TRABAJAR?</h4>
          <div class="mt-3">
            <CCard v-for="(item, index) in campus" :key="index" class="card text-center" @click="mtdSetCampu(item)"
              color="gradient-info" body-wrapper text-color="white">
              {{ item.name }}
            </CCard>
          </div>
        </div>

      </div>
    </div>


  </div>
</template>

<script>
export default {
  name: "c-home-campus",
  props: {
    campus: {
      type: Array,
      default: [],
    },
    logo: String,
  },
  methods: {
    mtdSetCampu: function (payload) {
      this.$emit("mtdSetCampu", payload);
    },
  },
};
</script>

<style scoped>
.card {
  cursor: pointer;
}

.contenedor {
  display: flex;
  align-items: center;
  height: 70vh;
  /* Ajusta según sea necesario */
}

.banner-image {
  width: 100%;
  height: auto;
  max-height: 100%;
  object-fit: cover;
}

#image-card,
#login-card {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
